import { extraValueTypes } from './constants'

export const getExtraValue = (method, language, currency = 'EUR') => {
  if (method.extra_value_type === extraValueTypes.fixedAmount) {
    const value = new Intl.NumberFormat(language, { style: 'currency', currency }).format(method.extra_value)
    return `+${value}`
  }
  if (method.extra_value_type === extraValueTypes.percentage) {
    return `+${parseFloat(method.extra_value)}%`
  }
}
